import { render } from "./DailySalesTotalCard.vue?vue&type=template&id=3883189a"
import script from "./DailySalesTotalCard.vue?vue&type=script&lang=js"
export * from "./DailySalesTotalCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__